import { doorLockPlan, doorRowItemType } from '../janus-engine/geometry/door-controls';
import { doorLockState } from '../janus-engine/geometry/door-lock-state';
import { actorRowFor, actorEncounterFor, bankConfirmedRev, confirmedRevFor, reconcileActorRow } from './movement-truth';
import { fetchAndCacheObject } from './object-cache';
import { geometryDoorBindings } from './inventory-floor-move-truth';
import { rowScalar } from '../encounter-map/ft3d/perception';
import { lockpickToolsGate } from './minigame-truth';
type Row=Record<string,unknown>;
interface DoorControlState {locked:boolean;hasKey:boolean;locks:{id:string;locked:boolean;hasKey:boolean;pickFailure:string|null}[]}
export async function doorControls(encounterId:string,hostId:string,actorId:string,rows:Row[],action?:'lock'|'unlock',selectedLockId?:string):Promise<DoorControlState> {
  const links=await geometryDoorBindings(encounterId,true);
  const status=(r:Row,side:'caster'|'target'):Row[]=>(ftCreatureStatuses(r,side)??[]) as Row[];
  const encounter=actorEncounterFor(encounterId) as Row|null;
  let actor=actorRowFor(encounterId,actorId) as unknown as Row|null;
  if(actorId && (!actor || !Array.isArray(actor.inventory))) actor=await fetchAndCacheObject(actorId) as Row|null;
  const locked=doorLockState(hostId,rows,links.rows,status);
  if(!actor||!encounter){if(action)throw new Error('door:actor-not-held');return{locked,hasKey:false,locks:[]};}
  const itemType=(r:Row):string=>doorRowItemType(r,actor!,encounter);
  const lockIds=new Set(links.rows.filter(b=>b.secured_id.toUpperCase()===hostId.toUpperCase()).map(b=>b.lock_id.toUpperCase()));
  const hostRow=rows.find(r=>String(rowScalar(r,'inventory_id')).toUpperCase()===hostId.toUpperCase());
  if(hostRow){
    if(itemType(hostRow)==='lock')lockIds.add(hostId.toUpperCase());
    for(const statusRow of status(hostRow,'target'))if(String(rowScalar(statusRow,'status_item_id')).toUpperCase()==='477A7977-60D2-4B9C-96B0-6ED4BFD6437E')lockIds.add(String(rowScalar(statusRow,'status_caster_id')).toUpperCase());
  }
  const locks=await Promise.all([...lockIds].map(async id=>{
    const hardware=rows.find(r=>String(rowScalar(r,'inventory_id')).toUpperCase()===id);
    const engaged=!!hardware&&status(hardware,'caster').some(s=>String(rowScalar(s,'status_item_id')).toUpperCase()==='477A7977-60D2-4B9C-96B0-6ED4BFD6437E');
    let hasKey=false;try{doorLockPlan(actor!,hostId,rows,links.rows,!engaged,itemType,id);hasKey=true;}catch{}
    const pickFailure=engaged?(await lockpickToolsGate(encounter,actor!,actorId,ftLayerEntries(hardware!,'requires_tool'))).failure:null;
    return{id,locked:engaged,hasKey,pickFailure};
  }));
  let plan:ReturnType<typeof doorLockPlan>;
  try{plan=doorLockPlan(actor,hostId,rows,links.rows,action? action==='lock':!locked,itemType,selectedLockId);}
  catch(error){if(action)throw error;return{locked,hasKey:false,locks};}
  if(!action)return{locked,hasKey:true,locks};
  const useKey = (window as Window & {ftTryCommitUseKey?: typeof import('./minigame-truth').tryCommitUseKey}).ftTryCommitUseKey;
  if (!useKey) throw new Error('door:key-browser-not-loaded');
  const result = await useKey({encounterId,actorId,lockInventoryId:plan.lockId,displayInventoryId:hostId,
    keyInventoryId:plan.keyId,action});
  if (!result || result.outcome !== 'handled') throw new Error(result?.message ?? 'door:key-plan-unavailable');
  const now = result.locked || locks.some(lock => lock.id !== plan.lockId && lock.locked);
  return {locked:now,hasKey:true,locks:locks.map(lock => lock.id===plan.lockId?{...lock,locked:result.locked}:lock)};
}
Object.assign(window,{ftDoorControls:doorControls});
Object.assign(window,{ftGeometryAdoptActor:(encounterId:string,actorId:string,receipt:Row):void=>{
  const actor=actorRowFor(encounterId,actorId),rev=Number(receipt.rev),aps=Number(receipt.aps);
  if(!actor||!Number.isInteger(rev)||!Number.isInteger(aps)||rev<confirmedRevFor(encounterId,actorId,actor))return;
  bankConfirmedRev(encounterId,actorId,actor,rev,{aps});
  reconcileActorRow(encounterId,actorId,actor);
}});
